import { capitalize } from "lodash";
import { RequestStatus } from "../interfaces";

export const getRequestStatus = (status: string) => {
  switch (status) {
    case RequestStatus.OPEN:
      return "Open";
    case RequestStatus.CLOSED:
      return "Closed";
    case RequestStatus.PROCESSING:
      return "Processing";
    case RequestStatus.RESOLVED:
      return "Resolved";
    default:
      return "";
  }
};

export const getRoleName = (role: string) => {
  return role
    .split("_")
    .map((r) => capitalize(r))
    .join(" ");
};
